import React, { Component, createRef, RefObject } from 'react'
import { SketchPicker, ColorResult } from 'react-color'
import InputLabel from './InputLabel'

interface Props {
  name: string
  value: string
  label?: string
  className?: string
  onChange: (name: string, value: string) => void
}

interface InputColorState {
  displayColorPicker: boolean
}

export default class InputColor extends Component<Props, InputColorState> {
  wrapperRef: RefObject<HTMLDivElement>

  constructor (props: Props) {
    super(props)
    this.wrapperRef = createRef<HTMLDivElement>()
    this.state = {
      displayColorPicker: false
    }
  }

  componentDidMount () {
    document.addEventListener('mousedown', this.handleDocumentClick)
  }

  componentWillUnmount () {
    document.removeEventListener('mousedown', this.handleDocumentClick)
  }

  get className () {
    const base = 'flex input-default cursor-pointer justify-between pr-0 items-center'
    return `${base} ${this.props.className || ''}`
  }

  get colorSwatch () {
    const style = { background: this.props.value || '#000000' }
    return <div className='h-full w-10 border-l border-gray-200' style={style}></div>
  }

  handleDocumentClick = (event: MouseEvent) => {
    const wrapper = this.wrapperRef.current
    if (!wrapper) return
    if (wrapper.contains(event.target as Node)) return
    this.setState({ displayColorPicker: false })
  }

  toggleColorPicker = () => {
    this.setState(prevState => ({
      displayColorPicker: !prevState.displayColorPicker
    }))
  }

  handleColorChange = (colorResult: ColorResult) => {
    this.props.onChange(this.props.name, colorResult.hex)
  }

  render () {
    const { displayColorPicker } = this.state

    return (
      <div className="block relative" ref={this.wrapperRef}>
        <InputLabel text={this.props.label} />
        <div
          className={this.className}
          onClick={this.toggleColorPicker}>
          <div className='truncate pr-2'>{this.props.value}</div>
          {this.colorSwatch}
        </div>

        {displayColorPicker && (
          <div
            className='absolute right-0 top-full mt-2 z-[1100] shadow-lg'
            onClick={(event) => event.stopPropagation()}>
            <SketchPicker
              color={this.props.value || '#000000'}
              onChange={this.handleColorChange}
            />
          </div>
        )}
      </div>
    )
  }
}
